import { useRequiredContext } from "@redotech/react-util/context";
import { EffectApiClientContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import { useQuery } from "@tanstack/react-query";
import { Effect } from "effect";

export function useIntegrations() {
  const effectApi = useRequiredContext(EffectApiClientContext);

  return useQuery({
    queryKey: ["integrations"],
    queryFn: async () => {
      const client = effectApi.getClient();

      const result = await effectApi.runPromise(
        client.integration
          .getTeamIntegrations({ urlParams: { limit: 100 } })
          .pipe(Effect.orDie),
      );

      return result.items;
    },
  });
}

export { type IntegrationWithChannelDataResponse } from "@redotech/effect-api-shared/models/shopper-ai/integration/integration";
